import script from "./volunteering-delete-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./volunteering-delete-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__